import { get } from 'lodash-es';
import type { GetExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const getResolver = createSimpleNamedExpressionResolver<GetExpression>(
  'get',
  get
);
